import AsyncStorage from '@react-native-async-storage/async-storage';
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useColorScheme as useNativeWindColorScheme } from 'nativewind';

const STORAGE_KEY = 'annedas_night_watch_v1';

type ThemeContextValue = {
  /** Açıkken koyu tema; kapalıyken açık tema (sistem teması kullanılmaz) */
  nightWatchEnabled: boolean;
  setNightWatchEnabled: (on: boolean) => void;
  /** `dark:` sınıfları için çözümlenmiş mod */
  isDark: boolean;
};

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { setColorScheme } = useNativeWindColorScheme();
  const [nightWatchEnabled, setNightWatchState] = useState(false);

  useEffect(() => {
    void AsyncStorage.getItem(STORAGE_KEY).then(v => {
      const on = v === '1';
      setNightWatchState(on);
      try {
        setColorScheme(on ? 'dark' : 'light');
      } catch {
        /* darkMode: class yapılandırılmadıysa */
      }
    });
  }, [setColorScheme]);

  const setNightWatchEnabled = useCallback(
    (on: boolean) => {
      setNightWatchState(on);
      void AsyncStorage.setItem(STORAGE_KEY, on ? '1' : '0');
      try {
        setColorScheme(on ? 'dark' : 'light');
      } catch {
        /* darkMode: class yapılandırılmadıysa */
      }
    },
    [setColorScheme],
  );

  const value = useMemo(
    () => ({
      nightWatchEnabled,
      setNightWatchEnabled,
      isDark: nightWatchEnabled,
    }),
    [nightWatchEnabled, setNightWatchEnabled],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useAppTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useAppTheme ThemeProvider dışında kullanılamaz');
  }
  return ctx;
}
